import { z } from 'zod'

export const trainerClientMemberExceptionResponseSchema = z.record(z.unknown())
export type TrainerClientMemberExceptionResponse = z.infer<typeof trainerClientMemberExceptionResponseSchema>
